import {
    Box,
    Card,
    CardBody,
    HStack,
    Heading,
    Image,
    Text,
    Tooltip,
    VStack,
} from "@chakra-ui/react";
import { CalenderIcon, InfoIcon, MapIcon } from "src/resources/icons";

import EVENT_IMAGE from "../../../../resources/icons/event-image.svg";
import { Event } from "src/types/commonTypes";
import React from "react";
import { getMonthAbbreviation } from "src/utils/globalUtils";

export interface CardComponentProps {
    event: Event;
}

export const EventCard: React.FC<CardComponentProps> = ({ event }) => {
    const [day, month, year] = event.date.split("/");
    const monthAbb = getMonthAbbreviation(parseInt(month)) ?? "--";

    return (
        <Card
            borderRadius="16px"
            boxShadow="0px 0px 4px 0px rgba(0, 0, 0, 0.04), 0px 8px 16px 0px rgba(0, 0, 0, 0.08)"
            minHeight="500px"
            maxHeight="550px"
            sx={{
            "@media screen and (max-width: 375px)": {
                minWidth: "300px",
                maxWidth: "300px",
            },
            "@media screen and (min-width: 376px)": {
                minWidth: "350px",
                maxWidth: "350px",
            },
            }}
        >
        <Box width="100%" position="relative" display="inline-block">
            {event?.date ? 
                <Image objectFit="cover" borderTopRadius="16px" width="100%" height="170px" alt="" src={event?.image ? event?.image : EVENT_IMAGE}/> :
                <Box
                    borderTopRadius="16px"
                    width="100%"
                    height="180px"
                    justifyItems="center"
                    alignContent="center"
                    bg="gray.100"
                >
                    <Image height="40%" alt="" src={event?.image}/>
                </Box>
            }
            <Box
                bottom="23px"
                right="23px"
                width="65px"
                height="65px"
                flexShrink="0"
                borderRadius="8px"
                backgroundColor="white"
                position="absolute"
            >
                <Text
                color="#4A2C2A"
                fontSize="24px"
                fontWeight="700"
                alignSelf="stretch"
                height="30px"
                textAlign="center"
                >
                {day}
                </Text>
                <Text
                color="rgba(74, 44, 42, 0.70)"
                fontSize="24px"
                fontWeight="700"
                alignItems="center"
                textAlign="center"
                >
                {monthAbb}
                </Text>
            </Box>
        </Box>
            <CardBody gap="2" justifyContent="flex-start">
            <Tooltip label={event.title} hasArrow>
                <Heading
                fontSize="24px"
                mb="20px"
                noOfLines={2}
                minHeight="70px"
                maxHeight="70px"
                >
                {event.title}
                </Heading>
            </Tooltip>
            <VStack alignItems="flex-start" spacing="15px">
                <HStack>
                    <InfoIcon />
                    <Text>{event.mode || "----" }</Text>
                </HStack>
                <HStack>
                    <CalenderIcon />
                    <Text>{event?.date ? `${day} ${monthAbb}, ${year}` : "----"}</Text>
                </HStack>
                <HStack alignItems="flex-start">
                    <MapIcon pl="1px" height={26} width={27} />
                    <Text>{event.location || "----"}</Text>
                </HStack>
            </VStack>
            </CardBody>
        </Card>
    );
};
